
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../level/ChunkBase";
import BoundsMarker from "../level/editor/BoundsMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class ChunkBoundaries {

	constructor(gameObject: ChunkBase) {
		this.gameObject = gameObject;
		(gameObject as any)["__ChunkBoundaries"] = this;

		/* START-USER-CTR-CODE */
		// Write your code here.
		/* END-USER-CTR-CODE */
	}

	static getComponent(gameObject: ChunkBase): ChunkBoundaries {
		return (gameObject as any)["__ChunkBoundaries"];
	}

	private gameObject: ChunkBase;
	public leftBoundsMarker!: BoundsMarker;
	public rightBoundsMarker!: BoundsMarker;

	/* START-USER-CODE */

	// Write your code here.

	/* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
